module.exports = __webpack_public_path__ + "img/antes_despues_167.adfd8461.png";